var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icSuccess_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1CD092",
  d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m4.27 8.33-4.75 4.75a1 1 0 0 1-1.41 0l-2.38-2.37a1.003 1.003 0 1 1 1.42-1.42L10.81 13l4-4a1 1 0 0 1 1.42 0 1 1 0 0 1 .04 1.33"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icSuccess_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "#fff"
})))));
export default SvgIcSuccess;